/** O nome da plataforma e o subtítulo da aplicação: "Live Gospel" sobre "Tecnologia para Igrejas". */
export const BRAND = {
  name: 'Live Gospel',
  /** Subtítulo da aplicação. */
  subtitle: 'Tecnologia para Igrejas',
  /** Mantido para retrocompatibilidade onde module era referenciado. */
  module: 'Tecnologia para Igrejas',
  /** Nome completo, em texto corrido e no título da aba. */
  full: 'Live Gospel',
  tagline: 'Tecnologia para Igrejas',
  /** Título da aplicação para o navegador. */
  browserTitle: 'Live Gospel - Tecnologia para Igrejas',
} as const;

/** Título da aba: "Página | Live Gospel - Tecnologia para Igrejas", ou o título padrão do navegador ("Live Gospel - Tecnologia para Igrejas"). */
export function pageTitle(title?: string): string {
  return title ? `${title} | ${BRAND.browserTitle}` : BRAND.browserTitle;
}
